import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import { PUT } from '../consts/Methods';
import apiRoot from '../consts/apiRoot';
import { CHANGE_USER_DATA, CHANGE_USER_DATA_SUCCESS, CHANGE_USER_DATA_FAIL } from '../redux/UserData';

function* changeUserDataFlow({ payload: { dealer, promise: { resolve, reject, }, }, }) {
  try {
    const endpoint = `${apiRoot}/profiles`;
    let params = dealer;
    const avatar = get(params, 'avatar');
    if (avatar && !avatar.startsWith('data:image')) {
      delete params.avatar;
    }
    const userData = yield call(apiCall, { method: PUT, endpoint, params: { dealer: params, }, });
    yield put(CHANGE_USER_DATA_SUCCESS({ userData, }));
    resolve();
  } catch (error) {
    yield put(CHANGE_USER_DATA_FAIL(error));
    reject();
  }
}

export default function* ChangeUserData() {
  yield takeLatest(CHANGE_USER_DATA, changeUserDataFlow);
}
